document.addEventListener('product:added', function(event) {
    fetch('/cart.js')
      .then(function(response) { return response.json(); })
      .then(function(data) {
          updateCartShippingProgress(data.total_price);
          window.custom.lastCartItem = data.items[0]?.product_id || data.items.product_id;
      });
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
});
// Free shipping progress + confetti are now driven by the cart drawer's
// free_shipping_bar block and its own re-render. Kept as a no-op shim so
// existing callers (theme.js, brutal-cart.js, custom.js) don't throw.
function updateCartShippingProgress(){}
/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
 document.addEventListener('variant:changed', function(event) {
    var variant = event.detail.variant; // Gives you access to the whole variant details
    //.variant-preview-image img
    if(variant.featured_image){
        const productId = variant.featured_image.product_id;
        const imagePreview = document.querySelector('img.variant-preview-image[data-product="' + productId + '"]');
        const imagePreviewWrapper = document.querySelector('a.twelve-product-img[data-product="' + productId + '"]');
        if(imagePreview){
            imagePreview.src = 'https:' + variant.featured_image.src;
            //add variant id to imagePreview
            imagePreviewWrapper.setAttribute('data-variant', variant.id);
            imagePreviewWrapper.classList.remove('inactive');
            imagePreviewWrapper.href = 'https:' + variant.featured_image.src;
            imagePreviewWrapper.setAttribute('data-fancybox', 'gallery')
            $(imagePreviewWrapper).show('slow');
            let varaitnId = variant.id;
            setTimeout(function(){
                $(`a.twelve-product-img[data-variant="${varaitnId}"]`).hide('slow');
            }, 5000,varaitnId);
        }
    }

});

 $(document).on('cart.requestComplete', function(event, cart) {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
       bubbles: true
     }));
});
 $('.seemore').click(function(e){
	e.preventDefault();
	var parent = $(this).parents('.collection__filter-checkbox-list');
	if(parent.find('[data-hidden-default]').hasClass('filter-item--hidden')){
		parent.find('[data-hidden-default]').removeClass('filter-item--hidden');
		$(this).text('See Less');
    }
	else{
		parent.find('[data-hidden-default]').addClass('filter-item--hidden');
		$(this).text('See More..');
    }	
})
$(".header__cart-toggle").on("click", function() {
    fetch('/cart.js')
      .then(function(response) { return response.json(); })
      .then(function(data) {
          updateCartShippingProgress(data.total_price);
      });
});


$(document).mouseup(function (e)
{
    var container = $(".select-box");

    if (container.has(e.target).length === 0)
    {
        container.removeClass("open");
    }
});

$("select .select_custom").on("change" , function() {
  
  var selection = $(this).find("option:selected").text(),
      labelFor = $(this).attr("id"),
      label = $("[for='" + labelFor + "']");
    
  label.find(".label-desc").html(selection);
    
});

function hideHeader(){
    $('#shopify-section-header > section > header > div > div > nav').hide('fast');
    $('#shopify-section-header > section > header > div > div > div.header__search-bar-wrapper').hide('fast');
    $('#shopify-section-header > section > header > div > div > div.header__action-list > div.header__action-item.header__action-item--cart.push-cart-icon > a > div > span').hide('fast');
    $('.header__logo').hide('fast');
    $('#shopify-section-header > section > header > div > div > div.header__action-list').css('position', 'absolute');
    $('#shopify-section-header > section > header > div > div > div.header__action-list').css('top', '-10000px');
    $('#shopify-section-header > section > header > div > div > div.header__action-list > div.header__action-item.header__action-item--cart.push-cart-icon > a > div > div').css('margin', '0');
    $('#shopify-section-header > section > header > div > div > div.header__action-list > div.header__action-item.header__action-item--cart').addClass('push-cart-icon');
    $('header').css('padding-top', '0');
    $('header').css('padding-bottom', '0');
}
function showHeader(){
    $('#shopify-section-header > section > header > div > div > nav').show('fast');
    $('#shopify-section-header > section > header > div > div > div.header__search-bar-wrapper').show('fast');
    $('#shopify-section-header > section > header > div > div > div.header__action-list > div.header__action-item.header__action-item--cart.push-cart-icon > a > div > span').show('fast');
    $('.header__logo').show('fast');
    $('#shopify-section-header > section > header > div > div > div.header__action-list').css('position', '');
    $('#shopify-section-header > section > header > div > div > div.header__action-list').css('top', '');
    $('#shopify-section-header > section > header > div > div > div.header__action-list > div.header__action-item.header__action-item--cart.push-cart-icon > a > div > div').css('margin', '');
    $('#shopify-section-header > section > header > div > div > div.header__action-list > div.header__action-item.header__action-item--cart').removeClass('push-cart-icon');
    $('header').css('padding-top', '');
    $('header').css('padding-bottom', '');
}
var scrollTicking = false;
$(window).on('scroll', function() {
    if (!scrollTicking) {
        window.requestAnimationFrame(function() {
            var scroll = $(window).scrollTop();
            if (scroll > 250) {
                hideHeader();
            }
            if (scroll < 100) {
                showHeader();
            }
            scrollTicking = false;
        });
        scrollTicking = true;
    }
});
var observer = new IntersectionObserver(function(entries) {
    if (entries[0].isIntersecting === true) {
        $(".view-more-button").trigger('click');
    }
}, { threshold: [1] });

if(document.querySelector(".view-more-button")){
    observer.observe(document.querySelector(".view-more-button"));
}
function formatMoney(cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.', ''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);
  
    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }
  
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');
  
      if (isNaN(number) || number == null) { return 0; }
  
      number = (number / 100.0).toFixed(precision);
  
      var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? (decimal + parts[1]) : '';
  
      return dollars + cents;
    }
  
    var match = formatString.match(placeholderRegex);
  
    if (match) {
      switch (match[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
      }
    }
  
    return formatString.replace(placeholderRegex, value);
  };

function openDialog(product) {
    document.querySelector("dialog[data-product='"+ product +"']").showModal();
}
function closeDialog(product) {
    document.querySelector("dialog[data-product='"+ product +"']").close();
}

// Read More

var readMoreBtn = document.getElementById("readMoreBtn");
if (readMoreBtn) {
    readMoreBtn.addEventListener("click", function () {
        const extraText = document.getElementById("extra-text");
        if (extraText.style.display === "none") {
            extraText.style.display = "block";
            readMoreBtn.textContent = "Read Less";
        } else {
            extraText.style.display = "none";
            readMoreBtn.textContent = "Read More";
        }
    });
}

var faqItems = document.querySelectorAll('.faq-item');
if (faqItems.length) {
    faqItems.forEach(function(item) {
        var question = item.querySelector('.faq-question');
        question.addEventListener('click', function() {
            item.classList.toggle('active');
        });
    });
}